import axios from 'axios';
import env from './../environment.js';
import { interceptarSinPermiso } from './avisar-sin-permiso.js';

export default interceptarSinPermiso(
  axios.create({
    baseURL: env.apiURL,
    headers: {
      'Content-type': 'multipart/form-data',
      Authorization: `Bearer ${localStorage.getItem(`${env.appName}-token`)}`,
    },
  })
);
